/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_No_Devices_NoteInputs */

const th_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีอุปกรณ์ที่ลงทะเบียนรับการแจ้งเตือน ตัวเลือกเหล่านี้จึงปิดอยู่ เปิดการแจ้งเตือนด้านบน หรือทำจากอุปกรณ์อื่น`)
};

const en_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No device is registered for push yet, so these are off. Turn on notifications above, or on another device.`)
};

const ja_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プッシュ通知に登録された端末がまだないため、これらはオフです。上で通知をオンにするか、他の端末で設定してください。`)
};

const zh_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚无设备注册推送，因此这里是关闭的。请在上面或在其他设备上打开通知。`)
};

const es_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay ningún dispositivo registrado, así que esto está desactivado. Activa las notificaciones arriba, o en otro dispositivo.`)
};

const pt_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dispositivo registrado ainda, então isto está desligado. Ligue as notificações acima, ou em outro dispositivo.`)
};

const id_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada perangkat yang terdaftar untuk push, jadi ini mati. Nyalakan notifikasi di atas, atau di perangkat lain.`)
};

const fr_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun appareil n’est encore enregistré, donc ceci est désactivé. Activez les notifications ci-dessus, ou sur un autre appareil.`)
};

const tl_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang device na nakarehistro para sa push, kaya patay ito. Buksan ang mga notipikasyon sa itaas, o sa ibang device.`)
};

const vi_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa thiết bị nào đăng ký nhận đẩy, nên mục này tắt. Hãy bật thông báo ở trên, hoặc trên thiết bị khác.`)
};

const ko_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`푸시에 등록된 기기가 아직 없어 꺼져 있습니다. 위에서, 또는 다른 기기에서 알림을 켜세요.`)
};

const de_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch ist kein Gerät für Push registriert, deshalb ist das hier aus. Schalte die Benachrichtigungen oben ein, oder auf einem anderen Gerät.`)
};

const ru_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ни одно устройство ещё не зарегистрировано для push, поэтому здесь выключено. Включите уведомления выше или на другом устройстве.`)
};

const tr_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz anlık bildirim için kayıtlı cihaz yok, bu yüzden burası kapalı. Yukarıdan ya da başka bir cihazdan bildirimleri açın.`)
};

const it_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dispositivo è ancora registrato per le notifiche push, quindi qui è disattivato. Attiva le notifiche qui sopra o su un altro dispositivo.`)
};

const pl_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żadne urządzenie nie jest jeszcze zarejestrowane do powiadomień push, więc to jest wyłączone. Włącz powiadomienia powyżej albo na innym urządzeniu.`)
};

const uk_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жодного пристрою ще не зареєстровано для push, тож тут вимкнено. Увімкніть сповіщення вище або на іншому пристрої.`)
};

const hi_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी पुश के लिए कोई उपकरण दर्ज नहीं है, इसलिए यह बंद है। ऊपर, या किसी दूसरे उपकरण पर सूचनाएँ चालू करें।`)
};

const ar_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد جهاز مسجَّل للإشعارات الفورية بعد، لذا هذا موقوف. فعّل الإشعارات أعلاه، أو على جهاز آخر.`)
};

const ms_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada peranti didaftarkan untuk tolakan, jadi ini dimatikan. Hidupkan pemberitahuan di atas, atau pada peranti lain.`)
};

const bn_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পুশের জন্য এখনও কোনও যন্ত্র নিবন্ধিত নয়, তাই এটি বন্ধ। উপরে, বা অন্য যন্ত্রে বিজ্ঞপ্তি চালু করুন।`)
};

const zh_tw2_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無裝置註冊推播，因此這裡是關閉的。請在上方或在其他裝置上開啟通知。`)
};

const zh_hk2_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無裝置註冊推播，因此這裡是關閉的。請在上方或在其他裝置上開啟通知。`)
};

const ur_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پُش کے لیے ابھی کوئی آلہ درج نہیں، اس لیے یہ بند ہے۔ اوپر، یا کسی دوسرے آلے پر اطلاعات چالو کریں۔`)
};

const fa_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز دستگاهی برای اعلان فوری ثبت نشده، پس اینجا خاموش است. اعلان‌ها را در بالا یا روی دستگاه دیگری روشن کنید.`)
};

const sw_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna kifaa kilichosajiliwa kupokea arifa bado, kwa hivyo hii imezimwa. Washa arifa hapo juu, au kwenye kifaa kingine.`)
};

const nl_push_no_devices_note = /** @type {(inputs: Push_No_Devices_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen apparaat geregistreerd voor push, dus dit staat uit. Zet de meldingen hierboven aan, of op een ander apparaat.`)
};

/**
* | output |
* | --- |
* | "No device is registered for push yet, so these are off. Turn on notifications above, or on another device." |
*
* @param {Push_No_Devices_NoteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_no_devices_note = /** @type {((inputs?: Push_No_Devices_NoteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_No_Devices_NoteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_no_devices_note(inputs)
	if (locale === "ja") return ja_push_no_devices_note(inputs)
	if (locale === "zh") return zh_push_no_devices_note(inputs)
	if (locale === "es") return es_push_no_devices_note(inputs)
	if (locale === "pt") return pt_push_no_devices_note(inputs)
	if (locale === "id") return id_push_no_devices_note(inputs)
	if (locale === "fr") return fr_push_no_devices_note(inputs)
	if (locale === "tl") return tl_push_no_devices_note(inputs)
	if (locale === "vi") return vi_push_no_devices_note(inputs)
	if (locale === "ko") return ko_push_no_devices_note(inputs)
	if (locale === "de") return de_push_no_devices_note(inputs)
	if (locale === "ru") return ru_push_no_devices_note(inputs)
	if (locale === "tr") return tr_push_no_devices_note(inputs)
	if (locale === "it") return it_push_no_devices_note(inputs)
	if (locale === "pl") return pl_push_no_devices_note(inputs)
	if (locale === "uk") return uk_push_no_devices_note(inputs)
	if (locale === "hi") return hi_push_no_devices_note(inputs)
	if (locale === "ar") return ar_push_no_devices_note(inputs)
	if (locale === "ms") return ms_push_no_devices_note(inputs)
	if (locale === "bn") return bn_push_no_devices_note(inputs)
	if (locale === "zh-TW") return zh_tw2_push_no_devices_note(inputs)
	if (locale === "zh-HK") return zh_hk2_push_no_devices_note(inputs)
	if (locale === "ur") return ur_push_no_devices_note(inputs)
	if (locale === "fa") return fa_push_no_devices_note(inputs)
	if (locale === "sw") return sw_push_no_devices_note(inputs)
	if (locale === "nl") return nl_push_no_devices_note(inputs)
	return en_push_no_devices_note(inputs)
});